import {interfaceLocale} from '../i18n';
// src/utils/dateUtils.js
// Utility date and color helpers used by AdminBookingCalendar and modal components.
import {localInstant,businessZone,wallDate} from './businessTime';

export function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}
export function endOfDayExclusive(d) {
  const e = startOfDay(d);
  e.setDate(e.getDate() + 1);
  return e;
}
export function startOfWeek(d) {
  const x = new Date(d);
  const day = x.getDay();
  const offset = (day + 6) % 7; // Monday start
  x.setDate(x.getDate() - offset);
  x.setHours(0, 0, 0, 0);
  return x;
}
export function endOfWeekExclusiveFromStart(start) {
  const e = new Date(start);
  e.setDate(e.getDate() + 7);
  return e;
}
export function capitalizeWord(s) {
  if (!s) return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}
export function formatSelectedDateHuman(d) {
  if (!d) return "";
  const day = d.getDate();
  const monthName = d.toLocaleDateString(interfaceLocale(), { month: "long" });
  const year = d.getFullYear();
  return `${day} de ${capitalizeWord(monthName)} ${year}`;
}

export function bookingScheduledAtToDate(data) {
  if (!data) return null;
  const sa = data.scheduledAt || data.startAt || data.scheduled_at || data.scheduled || null;
  try {
    if (sa instanceof Date && Number.isFinite(sa.getTime())) return new Date(sa);
    if (sa && typeof sa.toDate === "function") return sa.toDate();
    if (sa && sa.seconds) return new Date(sa.seconds * 1000);
    if (typeof sa === "string" || typeof sa === "number") {
      const d = new Date(sa);
      if (!isNaN(d.getTime())) return d;
    }
  } catch {}
  try {
    if (data.date) {
      let iso = String(data.date);
      if (data.time) {
        let t = String(data.time).trim();
        if (/^\d{1,2}:\d{2}$/.test(t)) t = t + ":00";
        iso = `${iso}T${t}`;
      } else iso = `${iso}T00:00:00`;
      const d = data.time ? localInstant(String(data.date).slice(0,10),String(data.time).padStart(5,'0').slice(0,5),businessZone(data)) : new Date(iso);
      if (!isNaN(d.getTime())) return d;
    }
  } catch {}
  return null;
}
export function bookingCalendarDate(data) {
  const instant=bookingScheduledAtToDate(data);
  return instant ? wallDate(instant,data || {}) : null;
}
export function bookingScheduledAtToISO(data) {
  const d = bookingScheduledAtToDate(data);
  try { return d ? d.toISOString() : ""; } catch { return ""; }
}
export function formatTimeRange(startIso, endIso) {
  try {
    const s = new Date(startIso);
    const e = new Date(endIso);
    const opts = { hour: "numeric", minute: "2-digit" };
    return `${s.toLocaleTimeString([], opts)} - ${e.toLocaleTimeString([], opts)}`;
  } catch {
    return "";
  }
}

const COLOR_PALETTE = ["#D1FAE5","#FEEFD4","#FCE7F3","#DBEAFE","#E6FFFA","#FFF7ED","#EEF2FF","#F8FAFC"];
export function colorForService(key) {
  if (!key) return COLOR_PALETTE[0];
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h << 5) - h + key.charCodeAt(i);
  return COLOR_PALETTE[Math.abs(h) % COLOR_PALETTE.length];
}
export function textColorByBg(bg) {
  try {
    const c = (bg || "#ffffff").replace("#", "");
    const r = parseInt(c.substring(0,2),16);
    const g = parseInt(c.substring(2,4),16);
    const b = parseInt(c.substring(4,6),16);
    const luminance = 0.2126*r + 0.7152*g + 0.0722*b;
    return luminance > 200 ? "#0f172a" : "#06394a";
  } catch { return "#0f172a"; }
}
